import React from 'react';
import fr from 'facet-rest';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import PropTypes from 'prop-types';
import Container from './Container';

const Icon = ({ resource }) => {
  return (
    <IncludedRelationshipProvider
      relationship={resource.relationship(fr.relationships.icon.name)}
    >
      <Container />
    </IncludedRelationshipProvider>
  );
};

Icon.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default Icon;
